import { cn } from '@/lib/utils';
import React from 'react';

type ElementType = keyof JSX.IntrinsicElements;

interface ContainerProps {
  children: React.ReactNode;
  className?: string;
  as?: ElementType;
  [key: string]: any;
}

const Container = ({ 
  children, 
  className, 
  as: Component = 'div', 
  ...props
}: ContainerProps) => {
  return (
    <Component className={cn('max-w-(--breakpoint-mui-md) mx-auto px-4', className)} {...props}>
      {children}
    </Component>
  );
};

export default Container;